import * as React from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import importAsync from "importAsync";
import { DashboardRoutes } from "areas/dashboard/DashboardRoutes";
import DashboardOverview from "areas/dashboard/DashboardOverview/DashboardOverview";
import UserProfileRoutes from "areas/users/UserProfileRoutes";
import ProjectGroupLayout from "areas/projects/components/ProjectGroupLayout";
import ReleaseRedirect from "areas/projects/components/Releases/ReleaseRedirect";
import DeploymentRoutes from "areas/deployments/DeploymentRoutes";
import Environment from "environment";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";
import routeLinks from "../../routeLinks";
import { V3EnvironmentRoutes } from "areas/infrastructure/components/InfrastructureRoutes/V3EnvironmentRoutes";
import { V3AccountRoutes } from "areas/infrastructure/components/InfrastructureRoutes/V3AccountRoutes";
import { V3MachineRoutes } from "areas/infrastructure/components/InfrastructureRoutes/V3MachineRoutes";
import { NotFound, RedirectAs404 } from "components/NotFound/NotFound";

const ProjectRoutes = importAsync(() => System.import(/* webpackChunkName: "projects" */ "areas/projects/components"), index => index.ProjectRoutes);
const LibraryRoutes = importAsync(() => System.import(/* webpackChunkName: "library" */ "areas/library/components"), index => index.LibraryRoutes);
const InfrastructureRoutes = importAsync(() => System.import(/* webpackChunkName: "infrastructure" */ "areas/infrastructure/components"), index => index.InfrastructureRoutes);
const TenantsRoutes = importAsync(() => System.import(/* webpackChunkName: "tenants" */ "areas/tenants"), index => index.TenantsRoutes);
const ConfigurationRoutes = importAsync(() => System.import(/* webpackChunkName: "configuration" */ "areas/configuration/components"), index => index.ConfigurationRoutes);
const TaskRoutes = importAsync(() => System.import(/* webpackChunkName: "tasks" */ "areas/tasks/components"), index => index.TaskRoutes);
const StyleGuide = importAsync(() => System.import(/* webpackChunkName: "styleGuide" */ "components/StyleGuide"), index => index.StyleGuide, !Environment.isInDevelopmentMode());
const CodeGuide = importAsync(() => System.import(/* webpackChunkName: "codeGuide" */ "components/CodeGuide"), index => index.CodeGuide, !Environment.isInDevelopmentMode());

const RootRoutes: React.StatelessComponent<{}> = props => (
    <Route render={({ location }) => {
        if (location.state && location.state.is404) {
            return <NotFound />;
        }

        // some links out in the wild contain / encoded to %2F which the angular router handled but react-router does not
        if (location.pathname.toUpperCase().includes("%2F")) {
            return <Redirect to={location.pathname.replace("%2F", "/").replace("%2f", "/").replace("//", "/")} />;
        }

        return <Switch>
                <ReloadableRoute exact path={routeLinks.root} component={DashboardOverview} />
                <ReloadableRoute path="/dashboard" component={DashboardRoutes} />
                <ReloadableRoute path={routeLinks.projects} component={ProjectRoutes} />
                <ReloadableRoute path="/projectgroups/:ProjectGroupId" component={ProjectGroupLayout} />
                <ReloadableRoute path={routeLinks.infrastructure.root} component={InfrastructureRoutes} />
                <ReloadableRoute path={routeLinks.tenants} component={TenantsRoutes} />
                <ReloadableRoute path={routeLinks.library.root} component={LibraryRoutes} />
                <ReloadableRoute path={routeLinks.tasks.root} component={TaskRoutes} />
                <ReloadableRoute path={routeLinks.release(":releaseId")} component={ReleaseRedirect} />
                <ReloadableRoute path="/deployments" component={DeploymentRoutes} />
                <ReloadableRoute path="/users/me" component={UserProfileRoutes} />
                <ReloadableRoute path="/configuration" component={ConfigurationRoutes} />
                <ReloadableRoute path="/style-guide" component={StyleGuide} />
                <ReloadableRoute path="/code-guide" component={CodeGuide} />
                <ReloadableRoute path="/manage/console" render={(p: any) => <Redirect to={{ ...p.location, pathname: routeLinks.tasks.console }} />} />
                <ReloadableRoute path="/environments" component={V3EnvironmentRoutes} />
                <ReloadableRoute path="/accounts" component={V3AccountRoutes} />
                <ReloadableRoute path="/machines" component={V3MachineRoutes} />
                <RedirectAs404 />
            </Switch>;
        }} />);

export default RootRoutes;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/RootRoutes/RootRoutes.tsx